export const withPath = (params: string[]) => params.join('');
